export type DadosBancariosSelectValue = string | number | undefined

export interface DadosBancariosLocal {
  bancoSelecionado: DadosBancariosSelectValue
  tipoContaSelecionado: DadosBancariosSelectValue
  agencia: string
  contaDadosBancarios: string
  digito: string
}

export const EMPTY_DADOS_BANCARIOS_LOCAL: DadosBancariosLocal = {
  bancoSelecionado: '',
  tipoContaSelecionado: '',
  agencia: '',
  contaDadosBancarios: '',
  digito: '',
}

export const buildDadosBancariosLocal = (
  dados: DadosBancariosLocal,
  shouldStartEmpty: boolean,
): DadosBancariosLocal => (shouldStartEmpty ? EMPTY_DADOS_BANCARIOS_LOCAL : dados)

const REQUIRED_FIELDS: (keyof DadosBancariosLocal)[] = [
  'bancoSelecionado',
  'tipoContaSelecionado',
  'agencia',
  'contaDadosBancarios',
  'digito',
]

export const isDadosBancariosFormComplete = (dados: DadosBancariosLocal): boolean =>
  REQUIRED_FIELDS.every((field) => Boolean(dados[field]))
